import axios from './axios';

export default {
  getById: async id => {
    const { data } = await axios.get(`/project-groups/${id}`);
    return data;
  },

  update: async (id, body) => {
    const { data } = await axios.put(`/project-groups/${id}`, body);
    return data;
  },

  delete: async id => {
    const { data } = await axios.delete(`/project-groups/${id}`);
    return data;
  },

  create: async body => {
    const { data } = await axios.post(`/project-groups`, body);
    return data;
  },

  getGroups: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/project-groups/${id}/project-groups`,
      params
    );

    return data;
  },

  getMembers: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/project-groups/${id}/members`, params);
    return data;
  },

  getDocuments: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/project-groups/${id}/documents`, params);
    return data;
  },

  updateLeader: async (id, profileId) => {
    const { data } = await axios.post(
      `/project-groups/${id}/leader?profileId=${profileId}`
    );
    return data;
  },

  getDocumentCount: async id => {
    const { data } = await axios.get(`/project-groups/${id}/document-count`);
    return data;
  },

  getMemberCount: async id => {
    const { data } = await axios.get(`/project-groups/${id}/member-count`);
    return data;
  },

  getTabCounters: async id => {
    const { data } = await axios.get(`/project-groups/${id}/tab-counters`);
    return data;
  }
};
